// Help icons
function makeHelper(help) {
    const target = help.nextSibling;

    if (!target) {
        return;
    }

    help.addEventListener('click', (event) => {
        event.preventDefault();
        if (target.classList.contains('help--show')) {
            target.classList.remove('help--show');
        } else {
            target.classList.add('help--show');
        }
    }, false);

    const close = target.querySelectorAll('[data-help-close]')[0];

    if (close) {
        close.addEventListener('click', event => {
            event.preventDefault();
            target.classList.remove('help--show');
        }, false);
    }
}

// Find all the help icons to enable
const helpers = document.querySelectorAll('[data-help]');
const arr = [].slice.call(helpers);

arr.forEach(help => {
    makeHelper(help);
});
